import React, { useMemo } from 'react';
import { formatDate } from 'src/adapters/dates.adapter';
import { SText } from 'src/components/SText';
import { $colors } from 'src/theme';
import { AlertSubscriptionLevel } from '../useSubscriptionAlert';

type Props = {
  testID?: string;
  level: AlertSubscriptionLevel;
  expireAt: Date | null;
};

export const SubscriptionNavBar: React.FC<Props> = ({ level, expireAt, testID = 'SubscriptionNavBar' }) => {
  const formattedDate = useMemo(() => {
    if (!expireAt) {
      return formatDate(new Date()).date;
    }

    return formatDate(expireAt).date;
  }, [expireAt]);

  if (!(['ALERT', 'WARNING'] as AlertSubscriptionLevel[]).includes(level)) {
    return null;
  }

  const danger = level === 'ALERT';
  return (
    <div className="w-full py-6 px-4" style={{ backgroundColor: danger ? $colors.error : $colors.warning }}>
      <SText
        label={danger ? 'subscription-agency-will-expire-alert' : 'subscription-agency-will-expire-warning'}
        translatingOptions={{
          date: formattedDate,
        }}
        style={{ color: $colors.white }}
      />
    </div>
  );
};
